<!-- eslint-disable max-len -->
<template lang="pug">
.input-wrapper
  span.input-label.p-small {{ label }} {{ requiredSymbol }}
  .form-control-icon
    Icon.icon(
      v-if='!!icon',
      :name='icon',
      :style='"width: 1.25rem; height: 1.5rem; margin-top: 18px !important;" + `color: var(--color-${getColorIcon}); `'
    )
    v-select#select-input.pt-3.pb-2(
      v-model='internalValue',
      :options='options',
      :class='["form-select", errorLog ? "invalid" : ""]',
      :filter="(options: any, search: any) => filterWithoutAccents(options, search, labelSelectable)"
      :placeholder='placeholder',
      :disabled='isDisabled',
      :label='labelSelectable',
  v-bind="!emitObject ? { reduce: (option: any) => (option && (option.value ?? option.nome ?? option.label ?? option)) } : {}"
      style='margin: 0'
    )
      template(v-slot:no-options) Nenhuma opção encontrada

  .invalid-feedback(v-if='!!errorLog')
    span.text {{ errorLog }}
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue'
  import Icon from './Icon.vue'
  import { filterWithoutAccents } from '@/utils/search'

  interface IOptionsSelectable {
    label: string
    value: string
    id?: number
  }

  export default defineComponent({
    name: 'SelectableComponent',
    emits: ['update:modelValue'],
    components: {
      Icon,
    },
    data: () => ({
      value: '',
    }),
    props: {
      emitObject: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        required: false,
      },
      icon: {
        type: String,
        required: false,
      },
      options: {
        type: Array as PropType<IOptionsSelectable[]>,
      },
      isDisabled: {
        type: Boolean,
      },
      isRequired: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
      },
      errorLog: {
        type: String,
        default: '',
      },
      modelValue: {
        type: null,
      },
      labelSelectable: {
        type: String,
      },
    },
    computed: {
      requiredSymbol() {
        return this.$props.isRequired && this.$props.label ? '*' : ''
      },
      getColorIcon() {
        if (this.$props.isDisabled) {
          return 'gray-dark'
        }

        if (this.$props.errorLog !== '') {
          return 'danger'
        }

        return 'primary'
      },
      internalValue: {
        get(): any {
          return (this as any).modelValue
        },
        set(value: any) {
          ;(this as any).$emit('update:modelValue', value)
        },
      },
    },
    methods: {
      filterWithoutAccents: filterWithoutAccents,
    },
  })
</script>

<style>
  #select-input {
    max-height: 30px;
  }

  .vs__dropdown-toggle {
    overflow: hidden;
  }

  .vs__dropdown-menu {
    padding: 0.5rem !important;
    margin-top: 16px !important;
    border-radius: 16px !important;
  }

  .vs__dropdown-option:hover,
  .vs__dropdown-option--highlight {
    background: #e6e7ec !important;
    border-radius: 16px !important;
    color: #2f3242 !important;
  }
</style>
